import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {share} from '../../utils/share'
import Swiper from '../Swiper/Swiper';
import shareImg from '../../static/images/share.jpg'
import img1 from '../../static/images/1loop1.png';
import img2 from '../../static/images/1loop2.jpg';
import img3 from '../../static/images/1loop3.jpg';
import img4 from '../../static/images/2loop1.jpg';
import img5 from '../../static/images/2loop2.jpg';
import img6 from '../../static/images/2loop3.jpg';
import bannerL from '../../static/images/bannerL.jpg';
import bannerS from '../../static/images/bannerS.jpg';
const wx = require('weixin-js-sdk'); // 必须使用require导入 weixin-js-sdk
function isTablet(){
    if (window.innerWidth > 550){
        return (<img src={bannerL} alt=""/>)
    }else{
        return (<img src={bannerS} alt=""/>)
    }
}
export default class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.handleLink = this.handleLink.bind(this)
    }

    componentDidMount() {
        share({
            title: '汉庭优佳，热力绽放',
            desc: '自助选枕、专业洗衣房、还有诸多细节，我只为您精心打造；汉庭优佳，美丽不止一面。',
            link: window.location.href,
            imgUrl: shareImg
        })
    }

    handleLink() {
        // 在小程序中打开，跳转小程序原生，非小程序，跳h5
        if (window.__wxjs_environment === 'miniprogram') {
            wx.miniProgram.navigateTo({url: '/pages/HotelList/List?cityId=3301&cityName=杭州'})
        } else {
            window.location.href = 'https://m.huazhu.com/Hotel/List?CityID=3301&CityName=杭州'
        }
    }

    render() {
        return <div className="main">
            <div className="banner">
                {isTablet()}
            </div>
            <div className="content">
                <div className="section">
                    <div className="line">
                        <div></div>
                        房价放假 <div></div></div>
                    <div className="sub-title">华住会员享受门市价8折</div>
                    <Swiper list={[img1, img2, img3]}/>
                </div>
                <div className="section">
                    <div className="line">
                        <div></div>
                        特色服务 <div></div></div>
                    <div className="sub-title">自助洗衣·自助选枕·行李寄存</div>
                    <Swiper list={[img4, img5, img6]}/>
                </div>
                <div className="section">

                </div>
                <div className="section">
                    <div className="title">会员预订规则</div>
                    <ul>
                        <li>当天可订，可续住，会员可享受相应积分和延迟退房政策；</li>
                        <li>订单需在1小时内全额预付房费，超过1小时订单自动取消；</li>
                        <li>入住当天中午12:00前可免费取消全额退款，逾时无法取消和退款</li>
                    </ul>
                </div>
            </div>
            <div className="button">
                <a href="http://m.huazhu.com/event/HTYJZ">立即预订</a>
            </div>

        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/Home.js